import React, { useState } from 'react';
import { getAdminPrivilegeColor } from '../utils/helpers';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  SimpleGrid,
  Spinner,
  useToast,
  HStack,
} from '@chakra-ui/react';
import { useAdminContext } from '../context/admin_context';

function PrestataireTable({ admins }) {
  const toast = useToast();
  const { deleteAdmin, fetchAdmins } = useAdminContext();
  const [loading, setLoading] = useState(false);


  const handleDelete = async (id) => {
    setLoading(true);
    const response = await deleteAdmin(id);
    setLoading(false);
    if (response.success) {
      toast({
        position: 'top',
        description: response.message,
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
      return await fetchAdmins();
    } else {
      return toast({
        position: 'top',
        description: response.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <SimpleGrid bg='white' p={5} shadow='lg' borderRadius='lg' overflowX='auto'>
      {loading ? (
        <HStack my={8} alignItems='center' justifyContent='center'>
          <Spinner size='lg' color='brown.500' />
        </HStack>
      ) : (
        <Table variant='simple'>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Email</Th>
              <Th>Privilege</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {admins.map((admin, index) => {const { name, email, privilege, id: adminId } = admin;
              return (
                <Tr key={index}>
                  <Td>{name}</Td>
                  <Td>{email}</Td>
                  <Td>
                    <Badge colorScheme={getAdminPrivilegeColor(privilege)}>
                      {privilege}
                    </Badge>
                  </Td>
                  <Td>
                    <HStack spacing='5'>
                      
                      <Button
                        variant='outline'
                        colorScheme='red'
                        onClick={() => handleDelete(adminId)}
                      >
                        Delete
                      </Button>
                    </HStack>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      )}
    </SimpleGrid>
  );
}

export default PrestataireTable;